<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">{{$route.query.name}}有以下贷款产品</div>
      <el-checkbox-group v-model="checkList">
        <el-checkbox v-for="(item, index) in list" :key="index" :label="item.id">
          <span class="num">{{item.productName}}</span>
          <span>贷款额度{{item.maxAmount}}万</span>
          <span v-if="item.applyProbability!='0%'">，申请概率{{item.applyProbability}}</span>
        </el-checkbox>
      </el-checkbox-group>
      <div class="btn">
        <el-button @click="$router.go(-1)">返回</el-button>
        <el-button class="sumbit" @click="sumbit()">申请提交</el-button>
      </div>
    </div>
    <Dialog
      :show="show"
      @dialogClose="dialogSumbitR"
      :title="'温馨提示'"
      :img="'success.png'"
      :content="'已提交'"
      :btn="'返回首页'"
      :btn2="'查看我的贷款'"
    />
  </div>
</template>

<script>
import Dialog from "@/components/Dialog";
import publicFun from "@/utils/publicFunction";
import HeaderImg from "@/components/HeaderImg";
import { sessionStore } from "@/utils/data-management";
export default {
  components: {
    Dialog,
    HeaderImg
  },
  data() {
    return {
      headerList: [
        { name: "产权流转交易中心", path: "/Home" },
        { name: "申请贷款" },
        { name: "贷款选择" }
      ],
      checkList: [],
      list: [],
      show: false
    };
  },
  methods: {
    init() {
      let data = {
        bankId: this.$route.query.id
      };
      this.$api.apply.loanProductList(data).then(res => {
        if (res.code == 1000) {
          this.list = res.data;
        }
      });
    },
    sumbit() {
      if (this.checkList.length < 1) {
        return this.$message.error("请选择要贷款的产品");
      }
      let arr = this.list.filter(item => this.checkList.indexOf(item.id) != -1);
      let data = arr.map(item => {
        return {
          id: item.id,
          bankId: item.bankId,
          bankName: item.bankName,
          propertyTradingCenter: item.propertyTradingCenter,
          productName: item.productName,
          maxAmount: item.maxAmount,
          area: item.area
        };
      });
      let params = {
        lenderId: sessionStore.get("userInfo").id,
        lenderName: sessionStore.get("userInfo").name,
        approvalStatus: this.$store.state.infoStatus,
        loanProductsEntities: data,
        loanApprovalFileEntities: sessionStore.get("loanFile"),
          farmersInfoId: sessionStore.get('farmersInfoId')
      };
      this.$api.apply.loanAdd(params).then(res => {
        if (res.code == 1000) {
          this.show = true;
          setTimeout(() => {
            this.dialogSumbitR();
          }, 1500);
        }
      });
    },
    dialogSumbitL() {
      this.$router.push("home");
    },
    dialogSumbitR() {
      this.$router.push("myLoan");
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.main-block {
  padding: 35px;
  .top-title {
    margin-bottom: 43px;
  }
  .el-checkbox-group {
    margin-left: 20px;
    .el-checkbox {
      display: block;
      margin-bottom: 30px;
      /deep/ .el-checkbox__label {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #60697e;
        .num {
          margin-right: 35px;
          color: #394259;
        }
      }
    }
  }
  .btn {
    margin-top: 210px;
    .el-button {
      border-radius: 2px;
    }
    .el-button + .el-button {
      margin-left: 20px;
    }
  }
}
</style>